export default __webpack_public_path__ + "static/couture.banner-d5e9138fdeadee052b3414c546d0226b.jpg";